export default __webpack_public_path__ + "static/media/visual-studio-code-icon.c95ccce2.svg";